import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { API_CONFIG, validateApiConfig } from './apiConfig';

type TokenGetter = () => string | null;

let tokenGetter: TokenGetter | null = null;

export const setTokenGetter = (getter: TokenGetter): void => {
  tokenGetter = getter;
};

const API_BASE_URL = API_CONFIG.BASE_URL;

const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

if (!validateApiConfig()) {
  console.error('API Client initialization failed: configuration validation failed');
}

apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    try {
      const token = tokenGetter?.();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    } catch (error) {
      console.error('Error getting token:', error);
      return config;
    }
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      if (typeof window !== 'undefined') {
        const currentPath = window.location.pathname;
        const loginUrl = `/login?error=SessionExpired&callbackUrl=${encodeURIComponent(currentPath)}`;
        window.location.href = loginUrl;
      }
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export default apiClient;
